import { render, staticRenderFns } from "./AddToCartIcon.vue?vue&type=template&id=5b8eaf22"
import script from "./AddToCartIcon.vue?vue&type=script&lang=ts"
export * from "./AddToCartIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports